import React from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Shared WatchButton component for watching addresses and coins
 * Provides consistent styling across the app
 */
const WatchButton = ({
  isWatching,
  loading,
  onClick,
  error,
  disabled,
  showLabel = true,
  size = 'default', // 'small' | 'default'
  className = ''
}) => {
  const sizeClasses = size === 'small'
    ? 'px-2 py-1 text-xs'
    : 'px-3 py-1.5 text-sm';

  const iconSize = size === 'small' ? 'w-3.5 h-3.5' : 'w-4 h-4';

  return (
    <div className={`inline-flex flex-col items-center ${className}`}>
      <button
        onClick={onClick}
        disabled={loading || disabled}
        className={`flex items-center gap-1.5 rounded-full font-medium transition whitespace-nowrap ${sizeClasses} ${
          isWatching
            ? 'bg-green-100 text-green-700 hover:bg-red-100 hover:text-red-700'
            : 'bg-gray-100 text-gray-600 hover:bg-blue-100 hover:text-blue-700'
        } ${(loading || disabled) ? 'opacity-50 cursor-not-allowed' : ''}`}
        title={isWatching ? 'Click to unwatch' : 'Click to watch'}
      >
        {loading ? (
          <span className={`${iconSize} border-2 border-current border-t-transparent rounded-full animate-spin`} />
        ) : isWatching ? (
          <Eye className={iconSize} />
        ) : (
          <EyeOff className={iconSize} />
        )}
        {showLabel && (
          <span>{isWatching ? 'Watching' : 'Watch'}</span>
        )}
      </button>
      {error && (
        <div className="text-xs text-red-600 mt-1 text-center">
          {error}
        </div>
      )}
    </div>
  );
};

export default WatchButton;
